import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
    const navigate = useNavigate();
    return (
        <>
            <div class="navbar bg-base-100 px-14">
                <div class="navbar-start">
                    <div class="dropdown">
                        <label tabindex="0" class="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabindex="0" class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                            <li><a className='font-semibold'>HOME</a></li>
                            <li><a className='font-semibold'>ABOUT</a></li>
                            <li><a className='font-semibold'>SKILLS</a></li>
                            <li><a className='font-semibold'>PROJECTS</a></li>
                            <li><a className='font-semibold'>RESUME</a></li>
                            <li><a className='font-semibold'>CONTACT</a></li>
                        </ul>
                    </div>
                    <a class="btn btn-ghost normal-case text-2xl"><span className='text-orange-500'>R</span>ana</a>
                </div>
                <div class="navbar-center hidden lg:flex">
                    <ul class="menu menu-horizontal p-0">
                        <li><Link to='/home' className='font-semibold'>HOME</Link></li>
                        <li><a href='#aboutme'className='font-semibold'>ABOUT</a></li>
                        <li><a  className='font-semibold'>SKILLS</a></li>
                        <li><a href='#projectsection' to='/projects' className='font-semibold'>PROJECTS</a></li>
                        <li><Link to='/blogs' className='font-semibold'>BLOGS</Link></li>
                        <li><a href="https://drive.google.com/file/d/1gZDQWax_kxBMwMu_2tBBqlCPr8ddE3sd/view?fbclid=IwAR1PL9jHZVVk9KJP42ozx0zM0agmrL8ySs4gLzdxRLi_Ltw3kQW5lPWcBFY" target="_blank" className='font-semibold'>DOWNLOAD RESUME</a></li>
                        <li><a href='#contactme' className='font-semibold'>CONTACT</a></li>
                    </ul>
                </div>
                {/* <div class="navbar-end">
                    <div class="form-control">
                        <label class="label cursor-pointer">
                            <input type="checkbox" class="toggle toggle-accent" checked />
                        </label>
                    </div>
                </div> */}
            </div>
        </>

    );
};

export default Navbar;